import { datadogRum } from '@datadog/browser-rum';
import { Environment } from '../types';
import { DATADOG_APPS_IDS, getObsEnvironment, isConsentGiven, shouldSkipConsent } from '../utils';
const API_TRACING_ALLOWLIST = [
    '/dbs/v1',
    '/cas/v1',
    '/cas/public/v1',
    '/pia/api/v1',
    '/pom/api/v1',
    '/ums/v1',
    '/scas/api/v2',
    '/realms/global/protocol/openid-connect/token',
    '/cps/api/v1',
    '/dds/api/v2',
    '/kci/api/v1',
    '/kss/api/v1',
    '/kcps/api/v1',
    '/das/v1',
    '/das/v2',
];
let isAPMInitialized = false;
export const fullSamplingZones = [];
const stagingEnabledZones = ['cp-dashboard'];
const setAPMTrackingConsentStatus = () => {
    const consentGiven = shouldSkipConsent() || isConsentGiven('DataDog');
    datadogRum.setTrackingConsent(consentGiven ? 'granted' : 'not-granted');
};
export const initializeAPM = ({ zoneName, version }) => {
    const dataDogServiceName = `frontend-${zoneName}`;
    const applicationId = DATADOG_APPS_IDS[dataDogServiceName];
    const env = process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === Environment.STAGING
        ? `bips-${Environment.STAGING}`
        : `bips-${Environment.PRODUCTION}`;
    const sessionSampleRate = (!!fullSamplingZones.length && fullSamplingZones.includes(zoneName)) ||
        process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === Environment.STAGING
        ? 100
        : 20;
    if (typeof localStorage !== 'undefined' &&
        applicationId &&
        (process.env.REACT_APP_ENV === Environment.PRODUCTION ||
            process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === Environment.PRODUCTION ||
            getObsEnvironment() === Environment.PRODUCTION ||
            (process.env.NEXT_PUBLIC_ENVIRONMENT_NAME === Environment.STAGING &&
                stagingEnabledZones.includes(zoneName)))) {
        setAPMTrackingConsentStatus();
        datadogRum.init({
            applicationId,
            clientToken: 'pub82869a5f257bd87fd12a8d9422df10f1',
            site: 'datadoghq.eu',
            service: dataDogServiceName,
            env,
            version,
            traceSampleRate: 100,
            sessionSampleRate,
            sessionReplaySampleRate: 0,
            telemetrySampleRate: 0,
            storeContextsAcrossPages: true,
            trackUserInteractions: false,
            trackResources: true,
            trackLongTasks: true,
            defaultPrivacyLevel: 'mask',
            allowedTracingUrls: API_TRACING_ALLOWLIST.map((prefix) => ({
                match: (url) => url.includes(prefix),
                propagatorTypes: ['tracecontext'],
            })),
        });
        isAPMInitialized = true;
        window.addEventListener('ucEvent', setAPMTrackingConsentStatus);
    }
};
export const addError = (...args) => {
    if (!isAPMInitialized)
        return;
    return datadogRum.addError(...args);
};
//# sourceMappingURL=rum.js.map